<script>
    import axios from 'axios'
    import findIndex from "lodash/findIndex";
    import InfiniteTree from 'infinite-tree';
    import ArtItems from './ArtItems.vue'
    import KSCreateNode from './node/KSCreateNode.vue'
    import KSMoveNode from './node/KSMoveNode.vue'
    import KSEmptyTrash from './node/KSEmptyTrash.vue'
    import KSCreateNodeFromFilter from './node/KSCreateNodeFromFilter.vue'
    import KSMoveKeysFromFilter from './../keys/KSMoveKeysFromFilter.vue'
    import KSDeleteNode from './node/KSDeleteNode.vue'
    import {elementBodyClickListener} from '../../../../lib/body-click-listener-helper'
    import KSSettingCluster from './../KSSettingCluster.vue'
    import KSTreeFilter from './../KSTreeFilter.vue'
    import AppMixin from './../../../../mixins/AppMixin'
    import {nextTick} from "vue";
    import {Listeners} from "../../../../constants/listeners";
    import {RecycleScroller} from "vue3-virtual-scroller";
    import {store} from "../../store";
    import {ClusteringSystemArts} from "../../constants/systemArts";

    InfiniteTree.prototype.getNodesInfo = function getNodesInfo() {

        let nodeIds;
        if(this.filtered){
            nodeIds = this.nodes.filter((n) => {return n.state.filtered === true}).map((n) => {return n.id});
        }else{
            nodeIds = this.nodes.map((n) => {return n.id});
        }

        let cachedNodes = {};

        for (let nodeId in this.nodeTable.data) {

            let node = this.nodeTable.data[nodeId],
                flattenNodes = this.flattenChildNodes(node);



            cachedNodes[nodeId] = {
                id: node.id,
                pid: node.parent.id,
                name: node.name,
                state: {
                    depth: node.state.depth,
                    open: node.state.open,
                    /*total: node.state.total,*/
                },
                keys_count: node.keys_count,
                ws_sum: node.ws_sum,
                wsk_sum: node.wsk_sum,
                superwsk_sum: node.superwsk_sum,
                max_key_ws: node.max_key_ws,
                max_key_wsk: node.max_key_wsk,
                max_key_superwsk: node.max_key_superwsk,
                has_children: node.children.length > 0,
                total_flatten: flattenNodes.length,
                lock: node.lock,
            }


        }

        return {nodeIds, cachedNodes};
    };

    InfiniteTree.prototype.cloneNode = (node = null) => {

        const traverse = (node) => {
            let s = '';
            if (node && node.children){

                let list = [];
                s = s + '{';


                Object.keys(node).forEach((key) => {
                    let value = node[key];
                    if (key === 'parent') {
                        return;
                    }
                    if (key === 'children') {
                        let ch = [];
                        for (let i = 0; i < node.children.length; ++i) {
                            ch.push(traverse(node.children[i]))
                        }

                        list.push('"' + key + '":[' + ch.join(',') + ']');

                        return;
                    }
                    if (typeof value === 'string' || typeof value === 'object') {
                        list.push('"' + key + '":' + JSON.stringify(value));
                    } else {
                        list.push('"' + key + '":' + value);
                    }
                });

                s = s + list.join(',');
                s = s + '}';
            }
            return s;
        };

        if (!node) {
            node = this.state.rootNode;
        }

        return '[' + traverse(node) + ']';

    };

    InfiniteTree.prototype.sortByField = function(node, settings) {

        let self = this;

        if(node.hasChildren()){

            this.closeNode(node);

            node.getChildren().sort(dynamicSort());

            this.openNode(node);
        }

        function dynamicSort() {
            let sortOrder = 1,
                property = settings.field;

            if(settings.dir === "desc") {
                sortOrder = -1;
            }

            return function (a,b) {
                if(a.id === -1 || a.id === -2 || a.id === -3 || b.id === -1 || b.id === -2 || b.id === -3){
                    return false;
                }

                let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        }



    };

    export default {
        mixins: [AppMixin],
        data() {
            return {
                contextListener: elementBodyClickListener(this, 'contextMenu', 'isContextMenu'),
                isContextMenu: false,
                ctxLeft: 0,
                ctxTop: 0,
                filter: "",
                phraseFilter: "",
                scrollHeight: 0,
                filterFields: {
                    'keys_count': ['keysCountLess', 'keysCountMore'],
                    'max_key_ws': ['wsMaxLess', 'wsMaxMore'],
                    'max_key_wsk': ['wskMaxLess', 'wskMaxMore'],
                    'max_key_superwsk': ['superwskMaxLess', 'superwskMaxMore'],
                    'ws_sum': ['wsSumLess', 'wsSumMore'],
                    'wsk_sum': ['wskSumLess', 'wskSumMore'],
                    'superwsk_sum': ['superwskSumLess', 'superwskSumMore'],
                },
                titlePadding: 0,
                store: store,
            }
        },
        props: [],
        methods: {
            setNodesInfo(nodeInfo) {
                this.store.mutations.setNodesInfo(nodeInfo);
            },
            setSelectContextNode(node) {
                this.store.mutations.setSelectContextNode(node);
            },
            setIsContext(val) {
                this.store.mutations.setIsContext(val);
            },
            setPositionFromEvent(el, ref) {
                let self = this;
                nextTick(() => {
                    self.ctxLeft = el.clientX;
                    self.ctxTop = el.clientY;
                });
            },

            createNode(model){
                let item = model ? model :  this.getSelectContextNode;
                this.$emitter.emit(Listeners.CLUSTER_CREATE_NODE, item);
            },

            updateNode(model){
                let item = model ? model :  this.getSelectContextNode;
                this.$emitter.emit(Listeners.CLUSTER_UPDATE_NODE, item);
            },

            deleteNode(model){
                let result = [].concat(this.getSelectNodes),
                    item = model ? model :  this.getSelectContextNode;

                let index = findIndex(this.getSelectNodes, {id: item.id});
                if(index === -1){
                    result.push(item);
                }

                this.$emitter.emit(Listeners.CLUSTER_DELETE_NODE, {model: result});
            },

            moveNode(model){
                let result = [].concat(this.getSelectNodes),
                    item = model ? model :  this.getSelectContextNode;

                let index = findIndex(this.getSelectNodes, {id: item.id});
                if(index === -1){
                    result.push(item);
                }

                this.$emitter.emit(Listeners.CLUSTER_MOVE_NODE_DIALOG, result);
            },

            lockNode(model){
                let item = model ? model :  this.getSelectContextNode;

                if(item.lock){
                    this.$emitter.emit(Listeners.CLUSTER_UNSET_LOCK_NODE, item);
                }else{
                    this.$emitter.emit(Listeners.CLUSTER_SET_LOCK_NODE, item);
                }

            },

            scrollToNode(){
                if(Object.keys(this.getSelectNode).length > 0){
                    this.$refs.recycleList.scrollToItem(this.getNodeIds.indexOf(this.getSelectNode.id));
                }
            },

            exportNode(model){
                let item = model ? model :  this.getSelectContextNode;
                this.$emitter.emit(Listeners.CLUSTER_EXPORT_NODE, item);
            },

            moveKeys(data){
                let self = this,
                    targetNode = this.$_tree.getNodeById(data.to),
                    fromNode = this.$_tree.getNodeById(data.from), filter = "";

                if(data['filter']){
                    filter = "?filter=" + data['filter'];
                    delete data['filter'];
                }

                axios({
                    method: 'post',
                    url: this.apiUrl+ '/' + data.to + '/keywords' + filter,
                    withCredentials: true,
                    data: data
                })
                .then(function (response) {
                    if (fromNode.id === self.getConstants.clusterResultId) {
                        self.$emitter.emit(Listeners.CLUSTER_TREE_RELOAD);
                    } else {
                        self.$_tree.updateNode(targetNode, response.data.to);
                        self.$_tree.updateNode(fromNode, response.data.from);
                    }

                    self.$_tree.sortByField(targetNode.getParent(), self.getSetting.sort);

                    if(targetNode.getParent().id !== fromNode.getParent().id){

                        self.$_tree.sortByField(fromNode.getParent(), self.getSetting.sort);

                    }

                    self.setNodesInfo(self.$_tree.getNodesInfo());
                    if(filter){
                        self.$emitter.emit(Listeners.KS_FILTER_CLEAR);
                    }else{
                        self.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                    }

                    self.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
                    self.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);

                }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                });

            },

            makeMasterKey(data){
                let self = this;

                axios({
                    method: 'post',
                    url: this.apiUrl+ '/make_master_key',
                    withCredentials: true,
                    data: {id: data.id}
                })
                .then(function (response) {

                    let node = self.$_tree.getNodeById(response.data.aid);

                    self.$_tree.updateNode(node, response.data.info);
                    self.setNodesInfo(self.$_tree.getNodesInfo());
                    self.$emitter.emit(Listeners.KS_FILTER_REFRESH);


                }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                });

            },

            onNodeClick(data) {
                //console.log(data);
            },

            onNodeRightClick: function (data) {
                this.onContextMenu(data);
            },

            onContextMenu(d) {
                if(d.model.id == -1 || d.model.id === -2){
                    return false;
                }
                if(!this.isContextMenu){
                    this.isContextMenu = true;
                }

                this.setSelectContextNode(d.model);
                this.setPositionFromEvent(d.el, 'contextMenu');
                this.contextListener.start();
            },


            loadPhraseMatches(filter){
                let self = this;

                this.phraseFilter = filter || "";

                if(!this.phraseFilter){
                    this.resetPhraseMatches();
                    return;
                }

                axios({
                    method: 'get',
                    url: this.apiUrl + '/keywords/arts?filter=' + this.phraseFilter,
                    withCredentials: true,
                })
                    .then(function (response) {
                        // пока шёл запрос, фильтр успели сменить или сбросить
                        if(filter !== self.phraseFilter){
                            return;
                        }

                        let matches = {};
                        response.data.forEach((item) => {
                            matches[item.id] = item.count;
                        });

                        self.store.mutations.setPhraseMatches(matches);
                        self.openMatchedAncestors();
                        self.doFilter();
                    }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                });
            },

            refreshPhraseMatches(){
                if(this.phraseFilter){
                    this.loadPhraseMatches(this.phraseFilter);
                }
            },

            resetPhraseMatches(){
                this.phraseFilter = "";

                if(this.getPhraseMatches === null){
                    return;
                }

                this.store.mutations.setPhraseMatches(null);
                this.doFilter();
            },

            // найденные группы внутри свёрнутых папок не попадут в список узлов, поэтому раскрываем их предков сверху вниз
            openMatchedAncestors(){
                const rootNode = this.$_tree.state.rootNode;

                for(let id in this.getPhraseMatches){
                    let node = this.$_tree.getNodeById(id),
                        ancestors = [];

                    for(let parent = node ? node.getParent() : null; parent && parent !== rootNode; parent = parent.getParent()){
                        ancestors.unshift(parent);
                    }

                    ancestors.forEach((ancestor) => this.$_tree.openNode(ancestor, {silent: true}));
                }
            },

            doFilter(){
                let self = this;

                if(!this.filter && !this.isTreeFilter && !this.getPhraseMatches){
                    this.$_tree.unfilter();
                    this.setNodesInfo(this.$_tree.getNodesInfo());
                    return false;
                }

                let search = self.filter.split("+");

                const filterOptions = {
                    exactMatch: false,
                    // у папки со своими найденными фразами не показываем все вложенные группы
                    includeDescendants: !self.getPhraseMatches
                };

                this.$_tree.filter((node) => {
                    const name = node.name || '';

                    let result = false,
                        pResult = [];

                    if(node.lock){
                        return true;
                    }

                    if(self.getPhraseMatches){
                        // «Результат кластеризации» — виртуальная папка, фраз с её id нет: без найденных
                        // групп она пропала бы из дерева, поэтому оставляем её всегда
                        if(node.id !== ClusteringSystemArts.CLUSTER_RESULT && !self.getPhraseMatches.hasOwnProperty(node.id)){
                            return false;
                        }

                        result = true;
                    }

                    if(self.isTreeFilter && node.id <= 0){
                        return false;
                    }

                    if(self.isTreeFilter){
                        for(let p in self.filterFields){
                            let less = self.filterFields[p][0],
                                more = self.filterFields[p][1];

                            if(self.getTreeFilter[more] !== null){
                                pResult.push(node[p] >= self.getTreeFilter[more]);
                            }

                            if(self.getTreeFilter[less] !== null){
                                pResult.push(node[p] <= self.getTreeFilter[less]);
                            }
                        }

                        result = pResult.every((r) => {return r === true});

                        if(!result){
                            return false;
                        }
                    }

                    if(self.filter){

                        if(search.length > 1){

                            result = search.every((q) => {
                                return name.toLowerCase().indexOf(q.toLowerCase().trim()) >= 0;
                            });

                        }else{
                            result = name.toLowerCase().indexOf(self.filter.toLowerCase().trim()) >= 0;
                        }

                    }


                    return result;

                }, filterOptions);

                this.setNodesInfo(this.$_tree.getNodesInfo());
            },
            showTour(){
                this.$emitter.emit(Listeners.CLUSTER_TOUR_START);
            },
            hasScrollBar(){
                let el = document.querySelector('.scroller');
                if(el){
                    return el.scrollHeight > el.clientHeight;
                }
                return false;
            },

            loadCluster() {

                let self = this;

                nextTick(() => {
                    self.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);
                });

                axios({
                    method: 'get',
                    url: self.apiUrl,
                    withCredentials: true,
                    params: {}
                })
                    .then(function (response) {

                        let options = {
                            autoOpen: false,
                            tabIndex: 0,
                            data: response.data,
                            width: '100%',
                            rowRenderer: () => ''
                        };

                        self.$_tree = new InfiniteTree(options);

                        self.$_tree.openNode(self.$_tree.getNodeById(0));
                        self.$_tree.openNode(self.$_tree.getNodeById(-3));

                        self.setNodesInfo(self.$_tree.getNodesInfo());

                        self.scrollToNode();

                        self.refreshPhraseMatches();

                        self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);
                    }).catch(function (error) {
                    self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                });


            },

            sortClass(field){
                return {
                    'fa fa-sort-asc': this.getSetting.sort.field === field && this.getSetting.sort.dir === 'asc',
                    'fa fa-sort-desc': this.getSetting.sort.field === field && this.getSetting.sort.dir === 'desc'
                };
            },

            changeSort(field) {
                let setting = JSON.parse(JSON.stringify(this.getSetting));

                if (this.getSetting.sort.field !== field) {
                    setting.sort.field = field;
                } else {
                    setting.sort.dir = setting.sort.dir === 'asc' ? 'desc' : 'asc'
                }

                let self = this;
                self.loading = true;
                axios({
                    method: 'post',
                    url: this.apiSettingUrl,
                    withCredentials: true,
                    data: setting
                })
                    .then(function (response) {

                        self.store.mutations.setSetting(setting);
                        self.loading = false;
                        self.loadCluster();

                    }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                });
            },
            onOpenKSSettingCluster() {
                this.$emitter.emit(Listeners.CLUSTER_POPUP_SETTING_OPEN);
            }
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getConstants() {
                return this.store.getters.constants();
            },
            getNodes() {
                return this.store.getters.nodes();
            },
            getNodeIds() {
                return this.store.getters.nodeIds();
            },
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getSelectNodes() {
                return this.store.getters.selectNodes();
            },
            getSelectContextNode() {
                return this.store.getters.selectContextNode();
            },
            getTreeFilter() {
                return this.store.getters.treeFilter();
            },
            getPhraseMatches() {
                return this.store.getters.phraseMatches();
            },
            getSetting() {
                return this.store.getters.setting();
            },
            getSettingViewCountWeight() {
                return this.store.getters.settingViewCountWeight();
            },
            getCountTitle() {
                return this.store.getters.countTitle();
            },
            contextMenuStyle () {
                return {
                    'position': 'fixed',
                    'display': this.isContextMenu ? 'block' : 'none',
                    'left': (this.ctxLeft || 0) + 'px',
                    'top': (this.ctxTop || 0) + 'px',
                }
            },
            disabledLock() {
                return this.getSelectNodes.length > 0
                    || Object.keys(this.getSelectNode).length === 0
                    || this.getSelectNode.id <= 0;
            },
            disabledAdd() {
                return this.getSelectNodes.length > 0
                    || Object.keys(this.getSelectNode).length === 0
                    || this.getSelectNode.id === -1
                    || this.getSelectNode.id === -2;
            },
            disabledRemove() {
                return Object.keys(this.getSelectNode).length === 0
                    || this.getSelectNode.id === 0
                    || this.getSelectNode.id === -1
                    || this.getSelectNode.id === -2;
            },
            disabledUpdate(){
                return this.getSelectNodes.length > 0
                    || Object.keys(this.getSelectNode).length === 0
                    || this.getSelectNode.id <= 0;
            },
            disabledContextItem() {
                let result = [this.getSelectContextNode].concat(this.getSelectNodes);

                return this.isContextMenu && result.length > 1;
            },
            disabledItem() {
                if (Object.keys(this.getSelectNode).length === 0) {
                    return true;
                }

                let result = [this.getSelectNode].concat(this.getSelectNodes);

                return result.length > 1;
            },
            apiUrl(){
                return this.$config.API_URL + '/clustering/' + 'node/' + this.getUid
            },
            apiSettingUrl(){
                return this.$config.API_URL + '/clustering/setting';
            },
            labelInfoTitle(){

                let result = [];

                if(this.getSetting.view){

                    for (let p in this.getSetting.view.treeNodeName) {
                        if(this.getSetting.view.treeNodeName[p].enabled){
                            result.push({
                                key: p,
                                title: this.getCountTitle[p].title,
                                abbr: this.getCountTitle[p].abbr,
                                width: this.getSettingViewCountWeight[p]
                            });
                        }
                    }

                }


                return result.reverse();
            },

            isTreeFilter(){
                let self = this;
                return Object.keys(this.getTreeFilter).some(function(key, index) {
                    return self.getTreeFilter[key] !== null;
                });
            },

        },
        watch: {
            isContextMenu(newVal, oldVal) {
                if (oldVal === true && newVal === false) {
                    this.contextListener.stop();
                    this.setIsContext(false);
                }else{
                    this.setIsContext(true);
                }
            },
            filter(newVal, oldVal) {
                if(!newVal) {
                    this.doFilter();
                }
            },
            getNodeIds() {
                let self = this;
                nextTick(function () {
                    self.titlePadding = self.hasScrollBar() ? 16 : 0;
                });

            }


        },
        components: {
            ArtItems,
            RecycleScroller,
            'ks-create-node': KSCreateNode,
            'ks-delete-node': KSDeleteNode,
            'ks-setting-cluster' : KSSettingCluster,
            'ks-tree-filter' : KSTreeFilter,
            'ks-create-node-from-filter': KSCreateNodeFromFilter,
            'ks-move-keys-from-filter': KSMoveKeysFromFilter,
            'ks-move-node': KSMoveNode,
            'ks-empty-trash': KSEmptyTrash,
        },
        created () {
            this.loadCluster();
        },
        mounted() {
            let scrollContainer = document.querySelector('.scroller'),
                self = this;

            nextTick(function () {
                self.scrollHeight = window.innerHeight - scrollContainer.offsetTop - scrollContainer.offsetParent.offsetTop;
            });

            this.$emitter.on(Listeners.CLUSTER_MOVE_KEYS, eventData => this.moveKeys(eventData));
            this.$emitter.on(Listeners.CLUSTER_REFRESH_FILTER, this.doFilter);
            this.$emitter.on(Listeners.KS_TABLE_MAKE_MASTER_KEY, eventData => this.makeMasterKey(eventData));
            this.$emitter.on(Listeners.CLUSTER_TREE_RELOAD, this.loadCluster);
            this.$emitter.on(Listeners.KS_FILTER_SET, eventData => this.loadPhraseMatches(eventData));
            this.$emitter.on(Listeners.KS_FILTER_REFRESH, this.refreshPhraseMatches);
            this.$emitter.on(Listeners.KS_FILTER_RESET, this.resetPhraseMatches);
            this.$emitter.on(Listeners.KS_DELETE_FILTER_PARAMS, this.resetPhraseMatches);
        }
    }
</script>
<template>

    <div class="arts__container">
        <ul class="ks-context-menu" tabindex="-1" ref="contextMenu" v-if="isContextMenu" :style="contextMenuStyle">
            <li @click.prevent="createNode(null)" :class="{'disabled-item': disabledContextItem}">
                {{$t('lang.cluster.m_add_folder')}}
            </li>
            <template v-if="getSelectContextNode.id !== 0">
                <li @click.prevent="deleteNode(null)">{{$t('lang.cluster.m_delete')}}</li>
                <li @click.prevent="moveNode(null)">{{$t('lang.cluster.m_move')}}</li>
            </template>
            <template v-if="getSelectContextNode.id > 0">
                <li @click.prevent="updateNode(null)" :class="{'disabled-item': disabledContextItem}">
                    {{$t('lang.cluster.m_rename')}}
                </li>
                <li @click.prevent="lockNode(null)" :class="{'disabled-item': disabledContextItem}">
                    <span v-if="!getSelectContextNode.lock">{{$t('lang.cluster.m_lock_folder')}}</span>
                    <span v-if="getSelectContextNode.lock">открепить папку</span>
                </li>
            </template>
            <li @click.prevent="exportNode(null)" :class="{'disabled-item': disabledContextItem}">
                {{$t('lang.cluster.m_lock_export')}}
            </li>
        </ul>

        <ks-create-node />
        <ks-delete-node />
        <ks-create-node-from-filter />
        <ks-move-keys-from-filter />
        <ks-move-node />
        <ks-empty-trash />

        <div class="f-row">
            <input type="search" class="cluster_search" v-model="filter" @keyup.enter="doFilter" id="tour-step-1" :style="{ width: isTreeFilter ? '45%' : '52%'}"/>
            <ks-tree-filter />
            <a id="tour-step-3" href="#" class="graybutton" :class="{'disabled': disabledItem}" @click.prevent="scrollToNode" :title="$t('lang.cluster.v_go_folder')"><i class="fa fa-dot-circle-o" aria-hidden="true"></i></a>
            <a id="tour-step-4" href="#" class="graybutton" :class="{'disabled': disabledAdd}" @click.prevent="createNode(getSelectNode)" :title="$t('lang.cluster.v_add_folder')"><i class="fa fa-plus-square" aria-hidden="true"></i></a>
            <a id="tour-step-5" href="#" class="graybutton" :class="{'disabled': disabledRemove}" @click.prevent="deleteNode(getSelectNode)" :title="$t('lang.cluster.v_remove_folder')"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
            <a id="tour-step-6" href="#" class="graybutton" :class="{'disabled': disabledUpdate}" @click.prevent="updateNode(getSelectNode)" :title="$t('lang.cluster.v_rename_folder')"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
            <a id="tour-step-7" href="#" class="graybutton" :class="{'disabled': disabledLock}" @click.prevent="lockNode(getSelectNode)" :title="getSelectNode.lock ? $t('lang.cluster.v_unlock_folder'):$t('lang.cluster.v_lock_folder')">
                <i class="fa fa-lock" aria-hidden="true" v-if="!getSelectNode.lock"></i>
                <i class="fa fa-unlock" aria-hidden="true" v-if="getSelectNode.lock"></i>
            </a>

            <a id="tour-step-7-1" href="#" class="graybutton" @click.prevent="onOpenKSSettingCluster" title="Общие настройки"><i class="fa fa-cog" aria-hidden="true"></i></a>
            <ks-setting-cluster />
        </div>

        <div class="f-row" :style="{'margin-right': titlePadding + 'px'}">
            <div style="height: 13px; width: 100%; position: relative;">
                <span v-for="info in labelInfoTitle" class="item-node-info" :title="info.title" :class="sortClass(info.key)" @click.prevent="changeSort(info.key)"
                      :style="{'width': info.width + 'px', 'font-weight': getSetting.sort.field === info.key ? '600' : 'inherit'}" v-html="info.abbr"></span>
            </div>
        </div>

        <RecycleScroller
                ref="recycleList"
                class="scroller"
                :style="{height: scrollHeight + 'px'}"
                :item-size="30"
                :items="getNodes"
                key-field="id"
        >

            <template v-slot="props">

                <art-items :model="props.item" :tree="$_tree" class="tree-item"
                           :on-node-right-click="onNodeRightClick"
                           :on-node-click="onNodeClick" :filter="filter" />

            </template>


        </RecycleScroller>
    </div>


</template>

<style>
    .arts__container {
        min-width: 300px;
    }
    .scroller {
        height: 100%;
        resize: vertical;
    }

    .vue-recycle-scroller__item-wrapper .vue-recycle-scroller__item-view{
        white-space: nowrap;
        font-size: 13px;
        height: 30px;
    }

    .item-node-info {
        float: right;
        font-size: 9px;
        line-height: 13px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
    }

    .disabled-item{
        pointer-events: none;
        color: #E0E0E0;
    }



</style>
